function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0089c6",
  d: "M9.73,14.21a4.81,4.81,0,0,1,.11-1H2.42l0,0V3.7l7.43,6L16.56,4V9.65A5,5,0,0,1,18.38,11V2.55A1.77,1.77,0,0,0,16.53.86H2.42A1.77,1.77,0,0,0,.57,2.55V13.17a1.76,1.76,0,0,0,1.85,1.68H9.8A4.48,4.48,0,0,1,9.73,14.21Zm6-11.7-5.91,5-6.15-5Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0089c6",
  d: "M14.53,9a5.07,5.07,0,1,0,5.07,5.07A5.07,5.07,0,0,0,14.53,9Zm3.12,3.77-3.17,3.64h0a.79.79,0,0,1-.53.22.73.73,0,0,1-.51-.21h0l-2-1.77h0a.74.74,0,0,1-.22-.53.72.72,0,0,1,.22-.52h0a.76.76,0,0,1,.52-.22.71.71,0,0,1,.51.21h0l1.47,1.25,2.65-3.1h0a.72.72,0,0,1,.52-.22.74.74,0,0,1,.53.22h0a.74.74,0,0,1,.22.52.75.75,0,0,1-.21.51Z"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.8ca60e0c.svg";
export { ForwardRef as ReactComponent };